import { ViewsApi, useAPIQuery } from "melco-shared-logic";

export const useMachineStatusView = (
  machineStatusViewId: string | null | undefined
) => {
  return useAPIQuery(
    ViewsApi,
    ["machineStatusViewGet", machineStatusViewId],
    async (api) => {
      if (machineStatusViewId == null || machineStatusViewId == "new") {
        return;
      }

      return await api.statisticalViewGet({ id: machineStatusViewId });
    }
  );
};
